import React, { useEffect, useState} from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { onStripeSystemDeauthorize } from "../../../store/Settings/actions";

export const StripePayment = ({stripeAccounts, stripeOauthLink}) => {
    const [auth,setAuth] = useState("")
    const dispatch = useDispatch();
    const { t } = useTranslation(); 

    useEffect(()=>{
        setAuth(stripeAccounts.map(item=>item.stripe_user_id))
    },[stripeAccounts])

    const accountId = stripeAccounts.find(item=>item); 

    const handleDeauthorize = () => {
        dispatch(onStripeSystemDeauthorize(accountId));
    };

    return (
        <div className="grid grid-cols-7 mb-5">
            <div className="col-start-1 col-end-4 bg-white p-5 mr-4">
                <p className="font-bold text-xl mb-1">
                    Stripe {t("Payment solution")}
                </p>
                <p className="font-medium text-sm">
                    {t(
                        "Please create an account by selecting Stripe below to receive customer payments. You will be able to login to your Stripe dashboard and manage customer payments."
                    )}
                </p>
            </div>

            <div className="flex items-center col-start-4 col-end-8 rounded-lg shadow-md bg-white p-5">
                {auth.length ? (
                    <>
                        <div className="mr-3">{auth}</div>
                        <div className="text-right">
                            <button
                                type="submit"
                                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-300 hover:bg-gray-400 activ:bg-gray-500 focus:outline-none"
                                onClick={handleDeauthorize}
                            >
                                {t("Deauthorize")}
                            </button>
                        </div>
                    </>
                ) : (
                    <a href={stripeOauthLink}>
                        <img
                            src="/Stripe.png"
                            alt="Stripe"
                            width={150}
                            height={150}
                        />
                    </a>
                )}
            </div>
        </div>
    );
};
